import { Flex, Text, Image } from "@chakra-ui/react";
import LanguageIcon from "assets/img/dashboards/language.svg";

interface LanguageColumnProps {
  from: string | string[];
  to: string | string[];
}

export const LanguageColumn = ({ from, to }: LanguageColumnProps) => {
  const normalize = (value: string | string[]) => {
    if (Array.isArray(value))
      return value.map((v) => String(v).trim()).filter(Boolean);
    if (!value) return [];

    return String(value)
      .split(/[,;\n]/g)
      .map((v) => v.trim())
      .filter(Boolean);
  };

  const fromList = normalize(from);
  const toList = normalize(to);

  const safeFromList = fromList.length > 0 ? fromList : [""];
  const safeToList = toList.length > 0 ? toList : [""];

  return (
    <Flex align="center" justify="center" gap="6px" minW="0">
      <Flex align="flex-start" flex="1" minW="0" gap="8px">
        <Flex direction="column" align="start" gap="2px" minW="0">
          {safeFromList.map((lang, idx) => (
            <Text
              key={`from-${idx}`}
              color="#0B0E10"
              fontSize="16px"
              lineHeight="24px"
              fontWeight="400"
              minW="0"
              isTruncated
            >
              {lang}
            </Text>
          ))}
        </Flex>

        <Text
          color="#0B0E10"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="400"
          flexShrink={0}
        >
          →
        </Text>

        <Flex direction="column" align="start" gap="2px" minW="0" flex="1">
          {safeToList.map((lang, idx) => (
            <Text
              key={`to-${idx}`}
              color="#0B0E10"
              fontSize="16px"
              lineHeight="24px"
              fontWeight="400"
              minW="0"
              isTruncated
            >
              {lang}
            </Text>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
